import { createApp } from 'vue'
import AlphabetGuide from '../components/AlphabetGuide.vue'

export function mountAlphabetGuide() {
  const el = document.getElementById('alphabet-guide-app')
  if (!el) return

  const app = createApp(AlphabetGuide, {
    practiceUrl: el.dataset.practiceUrl || null,
    unitId: el.dataset.unitId ? Number(el.dataset.unitId) : null,
    initialDialect: el.dataset.dialect || 'south',
    northAvailable: el.dataset.northAvailable === 'true',
  })
  app.mount(el)
}
